<template>
  <div class="ibox float-e-margins">
    <div class="ibox-title">
      <h5>Add Channel</h5>
    </div>
    <div class="ibox-content ibox-heading">
      <p>
        A channel is simply a mechanism by which we can get your interactions into the system be it by email,
        Facebook, WhatsApp, SMS... etc.
      </p>
      <p>Once we get the interaction, that's when the real magic happens! Choose a provider below to connect a new channel.</p>
    </div>
    <div>

    </div>
    <div class="ibox-content clearfix">
      <span
      v-for="cfg in channelTypeConfig"
      :key="cfg.title"
      @click="connectChannel(cfg.method || cfg.title)"
      >
        <div class="channel-add-item"  v-if="showChannelIcon(cfg.alwaysShow)">
          <span class="fa fa-fw fa-3x channel-logo" :class="cfg.icon" :style="`color: ${cfg.color}`"></span>
          <span class="channel-title" >{{cfg.title}}</span>
        </div>
      </span>

    </div>

    <facebook-create-dialog
      :me="me"
      :isVisible="showFacebookCreateDialog"
      @onFacebookChannelAdded="refetchChannelList"
      @onVisibleChanged="handleFacebookVisibilityChange"
    />

    <instagram-create-dialog
      :me="me"
      :isVisible="showInstagramCreateDialog"
      @onFacebookChannelAdded="refetchChannelList"
      @onVisibleChanged="handleInstagramVisibilityChange"
    />

    <email-channel-create-dialog
      :me="me"
      :isVisible="showEmailCreateDialog"
      @onEmailChannelAdded="refetchChannelList"
      @onVisibleChanged="handleEmailDialogVisibilityChange"
    />

    <wechat-channel-create-dialog
      :isVisible="showWechatCreateDialog"
      @onEmailChannelAdded="refetchChannelList"
      @onVisibleChanged="handleWechatDialogVisibilityChange"
    />

    <whatsapp-web-channel-create-dialog
      :isVisible="showWhatsAppWebCreateDialog"
      @onWhatsappChannelAdded="refetchChannelList"
      @onVisibleChanged="handleWhatsappWebDialogVisibilityChange"
    />

    <telegram-channel-create-dialog
      :isVisible="showTelegramCreateDialog"
      @onWhatsappChannelAdded="refetchChannelList"
      @onVisibleChanged="handleTelegramDialogVisibilityChange"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import SocialIcon from '@/components/common/Icons/SocialIcon';
import FacebookCreateDialog from '@/components/channel/facebook/FacebookCreateDialog';
import InstagramCreateDialog from '@/components/channel/instagram/InstagramCreateDialog';
import TelegramChannelCreateDialog from '@/components/channel/telegram/TelegramNewDialog';
import EmailChannelCreateDialog from '@/components/channel/email/EmailChannelCreateDialog';
import WechatChannelCreateDialog from '@/components/channel/wechat/WechatChannelCreateDialog';
import WhatsappWebChannelCreateDialog from '@/components/channel/whatsappweb/WhatsappWebChannelCreateDialog';
import channelCreateMixin from './channelCreateMixin';

export default {
  name: 'ChannelCreate',
  mixins: [channelCreateMixin],
  components: {
    SocialIcon,
    FacebookCreateDialog,
    InstagramCreateDialog,
    EmailChannelCreateDialog,
    WechatChannelCreateDialog,
    TelegramChannelCreateDialog,
    WhatsappWebChannelCreateDialog,
  },
  data: () => ({
    selectedChannelType: null,
  }),
  computed: {
    ...mapState('user', ['me']),
  },

  methods: {
    showChannelIcon(alwaysShow) {
      if (alwaysShow) {
        return alwaysShow;
      }
      return alwaysShow || this.me.is_staff;
    },
  },
};
/* eslint-enable no-console */
</script>

<style lang="scss" scoped>
@import '../../assets/style/_variables_live.scss';

.channel-add-item {
  display: inline-block;
  width: 120px;
  height: 120px;
  margin: 8px;
  padding: 15px;
  border: 1px solid #e9e9e9;
  border-radius: 3px;

  &:hover {
    box-shadow: 2px 2px 7px 0 #ddd;
    transition: box-shadow 0.3s ease;
  }
}

.channel-logo {
  margin: 5px auto;
  padding: 10px 5px;
  width: 100%;
  display: block;
}

.channel-title {
  color: $text-color;
  font-weight: bold;
  // font-size: 1.25em;
  text-align: center;
  width: 100%;
  display: block;
}

.ibox {
  background-color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// ChannelCreate.vue?7d3c5389